import Vue from 'vue'
import App from './App.vue'
import router from './router'

// Optional: Add global styles
// import './assets/styles/global.css'

// Optional: Add any global components you want to use everywhere
// import GlobalComponent from './components/GlobalComponent.vue'
// Vue.component('global-component', GlobalComponent)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')